import {BFCM, PLAN_NO, PLAN_TYPE} from "@/contants/plan";

const getters = {
  leftSections: state => state.sectionsOrders.left,
  rightSections: state => state.sectionsOrders.right,
  blog: (state) => state.blog,
  faqs: (state) => state.faqs,
  changelog: (state) => state.changelog,
  recentPages: (state) => state.recentPages,
  startedGuideStep: (state) => state.startedGuideStep,
  openCustom: (state) => state.openCustom,
  banner: (state) => state.banner,
  loading: (state) => state.loading,
  firstCallGetApi: (state) => state.firstCallGetApi,
  bfcmBannerClosed: (state) => state.bfcmBannerClosed,
  isBFCM: (state) => {
    const {paymentInfo} = state
    if (!paymentInfo || !paymentInfo.plans || !paymentInfo.planType === PLAN_NO.TRIAL2022) return false

    return !!paymentInfo.plans.find(plan => {
      const { planType, appliedPromotion } = plan
      return planType === PLAN_TYPE.MONTHLY && appliedPromotion && appliedPromotion.code === BFCM
    })
  }
};

export default getters;
